import { createAuthenticatedHttpClient } from 'src/modules/seek-api-request';

export const isAuthenticated = async () => {
  try {
    return (await createAuthenticatedHttpClient().getToken()).authenticated;
  } catch {
    return false;
  }
};

export const getCandidateUserIdFromTokenIdentity = async () => {
  try {
    const token = await createAuthenticatedHttpClient().getToken();
    if (token.authenticated && token.identity) {
      return Number(token.identity.sub.userId);
    }
  } catch {}
};
